module.exports = __webpack_public_path__ + "img/SW.02ad2687.png";